import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Layout/Header';

// Function to extract user-friendly error message
const getShortErrorMessage = (error) => {
  if (!error || typeof error !== 'string') {
    return 'Sprawdź link i spróbuj ponownie.';
  }
  
  // Connection errors
  if (error.includes('Connection') || error.includes('connection')) {
    return 'Podaj prawidłowy link do filmu z YouTube.';
  }
  
  // Duration error
  if (error.includes('10 minut') || error.includes('600 sekund')) {
    return 'Film jest zbyt długi. Maksymalna długość to 10 minut.';
  }
  
  // Format not available / no audio
  if (error.includes('format is not available') || error.includes('no audio formats')) {
    return 'Nie można pobrać audio z tego filmu. YouTube może blokować dostęp.';
  }
  
  // Sign in required / bot detection
  if (error.includes('Sign in') || error.includes('bot')) {
    return 'YouTube wymaga weryfikacji. Spróbuj ponownie za chwilę.';
  }
  
  // Empty file / fragments not found
  if (error.includes('empty') || error.includes('fragment not found')) {
    return 'Pobieranie nie powiodło się. Spróbuj ponownie.';
  }
  
  // Video unavailable
  if (error.includes('unavailable') || error.includes('private') || error.includes('removed')) {
    return 'Film jest niedostępny lub prywatny.';
  }
  
  // Age restricted
  if (error.includes('age') || error.includes('restricted')) {
    return 'Film ma ograniczenia wiekowe i nie może być pobrany.';
  }
  
  // Generic Python/download error - show short version
  if (error.includes('Python script failed') || error.includes('Download failed')) {
    return 'Wystąpił problem z pobieraniem. Spróbuj ponownie za chwilę.';
  }
  
  // If error is very long, truncate it
  if (error.length > 100) {
    return 'Wystąpił problem z pobieraniem. Spróbuj ponownie.';
  }
  
  return error;
};

const ErrorPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const rawError = location.state?.error || 'Wystąpił nieoczekiwany błąd';
  const error = getShortErrorMessage(rawError);

  return (
    <div className="bg-background-light dark:bg-background-dark min-h-screen flex flex-col overflow-x-hidden">
      <Header />

      <div className="flex-1 flex items-center justify-center p-4 w-full">
        <div className="w-full max-w-[520px]">
          <div className="flex flex-col items-center gap-6 mb-10">
            <div className="relative group">
              <div className="absolute -inset-4 bg-red-500/20 rounded-full blur-xl opacity-50 group-hover:opacity-75 transition-opacity duration-700"></div>
              <div className="relative w-32 h-32 bg-surface-dark rounded-2xl shadow-2xl flex items-center justify-center overflow-hidden border border-surface-border">
                <img 
                  src="/logo.png" 
                  alt="Logo" 
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="text-center space-y-2 mt-4">
              <h1 className="text-slate-900 dark:text-white tracking-tight text-[32px] font-bold leading-tight px-4 pb-1">
                Konwerter MP3
              </h1>
              <p className="text-slate-500 dark:text-slate-400 text-base font-normal leading-normal px-4">
                Wystąpił błąd podczas konwersji. Proszę spróbować ponownie.
              </p>
            </div>
          </div>

          <div className="bg-white dark:bg-surface-dark rounded-xl border border-gray-200 dark:border-surface-border shadow-sm p-8 w-full">
            <div className="flex flex-col items-center gap-6">
              <div className="size-16 rounded-full bg-red-500/10 flex items-center justify-center text-red-500">
                <span className="material-symbols-outlined text-[32px]">error</span>
              </div>

              <div className="text-center space-y-1">
                <p className="text-slate-900 dark:text-white text-lg font-bold leading-snug">
                  Wystąpił błąd
                </p>
                <p className="text-slate-500 dark:text-slate-400 text-sm font-normal leading-normal">
                  {error}
                </p>
              </div>

              <div className="w-full mt-2">
                <button
                  onClick={() => navigate('/')}
                  className="w-full flex items-center justify-center px-6 py-3 rounded-lg border border-gray-200 dark:border-surface-border text-slate-900 dark:text-white hover:bg-slate-100 dark:hover:bg-surface-border transition-colors font-medium text-sm"
                >
                  Strona główna
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
